import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  location: string;
  text: string;
}
export function TestimonialCard({
  name,
  age,
  location,
  text
}: TestimonialProps) {
  return <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-sm border border-purple-100 hover:shadow-md transition-shadow duration-300" data-id="element-11">
      <div className="flex gap-1 mb-4" data-id="element-12">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-13" />)}
      </div>
      <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-14">"{text}"</p>
      <div className="flex items-center gap-3" data-id="element-15">
        <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 font-serif font-bold text-lg" data-id="element-16">
          {name.charAt(0)}
        </div>
        <div data-id="element-17">
          <p className="font-medium text-gray-900" data-id="element-18">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-19">
            {age} años • {location}
          </p>
        </div>
      </div>
    </div>;
}